'use strict';
const nodeCenterPoint = require('./node-center-point'),
	nodeConnectionPointY = {
		'center': function (node) {
			return Math.round(node.top + node.height * 0.5);
		},
		'center-outset': (node, relatedNode, inset, connectorTheme) => {
			const relatedNodeCenter = nodeCenterPoint(relatedNode),
				nodeCenter = nodeCenterPoint(node),
				margin = connectorTheme.line.arrowExtension.length + connectorTheme.line.width,
				halfWidth = (node.width / 2) + margin,
				halfHeight = (node.height / 2) + margin,
				v = {dy: relatedNodeCenter.y - nodeCenter.y, dx: relatedNodeCenter.x - nodeCenter.x},

				dy1 = v.dx ? Math.abs(v.dy * halfWidth / v.dx) : halfHeight,
				dy = Math.min(dy1, halfHeight) * Math.sign(v.dy);

			return nodeCenter.y + dy;
		},
		'base-inset': function (node, relatedNode, inset) {
			return node.top + node.height + (-inset || 1);
		},
		'base': function (node) {
			return node.top + node.height + 1;
		},
		'base-outset': function (node, relatedNode, inset, connectorTheme) {
			const margin = connectorTheme.line.arrowExtension.length + connectorTheme.line.width;
			return node.top + node.height + margin;
		},
		'nearest': function (node, relatedNode, inset) {
			const relatedNodeCenter = nodeCenterPoint(relatedNode),
				nodeCenter = nodeCenterPoint(node);
			if (relatedNodeCenter.y < node.top + node.height - inset &&
				relatedNodeCenter.y > node.top + inset) {
				return relatedNodeCenter.y;
			} else if (relatedNodeCenter.y < nodeCenter.y) {
				return nodeConnectionPointY['top-inset'](node, relatedNode, inset);
			} else {
				return nodeConnectionPointY['base-inset'](node, relatedNode, inset);
			}
		},
		'nearest-outset': function (node, relatedNode, inset, connectorTheme) {
			const nodeCenter = nodeCenterPoint(node);
			if (node.top + node.height - inset < relatedNode.top) {
				return nodeConnectionPointY['base-outset'](node, relatedNode, inset, connectorTheme);
			}
			if (node.top > relatedNode.top + relatedNode.height - inset) {
				return nodeConnectionPointY['top-outset'](node, relatedNode, inset, connectorTheme);
			}
			return nodeCenter.y;
		},
		'top': function (node) {
			return node.top - 1;
		},
		'top-inset': function (node, relatedNode, inset) {
			return node.top + inset;
		},
		'top-outset': function (node, relatedNode, inset, connectorTheme) {
			const margin = connectorTheme.line.arrowExtension.length + /* 1.5 * */ connectorTheme.line.width;
			return node.top - margin;
		},
		'center-separated-inset': function (node, relatedNode, inset) {
			const nodeCenter = nodeCenterPoint(node),
				halfWidth = node.width / 2,
				maxOffset = (node.height / 2) - inset,
				realatedNodeCenter = nodeCenterPoint(relatedNode),
				centerVector = {dx: realatedNodeCenter.x - nodeCenter.x, dy: realatedNodeCenter.y - nodeCenter.y},
				offsetY = (halfWidth * centerVector.dy) / centerVector.dx,
				cappedOffsetY = offsetY > 0 ? Math.min(offsetY, maxOffset) : Math.max(offsetY, (-1 * maxOffset));
			return Math.round(nodeCenter.y + cappedOffsetY);

		}
	};

module.exports = nodeConnectionPointY;
